import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cx from 'classnames';

import Button from '../Button';
import './ReservationButton.scss';

const ReservationButton = ({
  ariaDescribedBy,
  badge,
  fullWidth,
  id,
  tableType,
  time,
  ...props
}) => {
  const renderBadge = () => {
    if (badge) {
      const style = {
        backgroundColor: `#${badge.background || '3bc43f'}`,
        backgroundImage: `url(${
          badge.url || 'https://s3.amazonaws.com/resy.com/images/badges/hi.png'
        })`,
      };
      return <span className="ReservationButton__badge" style={style} />;
    }
    return null;
  };

  const renderTime = () => moment(time, 'YYYY-MM-DD HH:mm:ss').format('LT');

  return (
    <Button
      data-testid={`reservation-button-${id}`}
      aria-describedby={ariaDescribedBy}
      className={cx('ReservationButton', {
        'ReservationButton--full-width': fullWidth,
      })}
      {...props}
    >
      {renderBadge()}
      <div className="ReservationButton__time">{renderTime()}</div>
      <div className="ReservationButton__type">{tableType}</div>
    </Button>
  );
};

ReservationButton.propTypes = {
  ariaDescribedBy: PropTypes.string,
  badge: PropTypes.shape({
    background: PropTypes.string,
    url: PropTypes.string,
  }),
  colors: PropTypes.shape({
    background: PropTypes.string,
    font: PropTypes.string,
  }),
  fullWidth: PropTypes.bool,
  id: PropTypes.string.isRequired,
  tableType: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

ReservationButton.defaultProps = {
  ariaDescribedBy: undefined,
  badge: null,
  colors: {},
  fullWidth: false,
};

ReservationButton.displayName = 'ReservationButton';
export default ReservationButton;
